import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Row, Skeleton } from "antd";
import moment from "moment";

import summaryApi from "../../apis/Summary.api";

const convertCategoryType = (item) => {
	if (item?.category_type === "ingredient") {
		return `성분별`;
	} else if (item?.category_type === "function") {
		return `고민별`;
	} else if (item?.category_type === "combination") {
		return `조합별`;
	} else if (item?.category_type === "community") {
		return `소통`;
	} else if (item?.category_type === "recommend_nutrients") {
		return `문의글`;
	} else if (item?.category_type === "cooperate") {
		return `공동구매`;
	} else if (item?.category_type === "mission") {
		return `클래스`;
	} else if (item?.category_type === "event") {
		return `이벤트`;
	}
};

const PopularCategory = () => {
	const user = useSelector((state) => state.auth.user);
	const [loading, setLoading] = useState(false);
	const [dateLength, setDateLength] = useState(2);
	const [categoryList, setCategoryList] = useState([]);

	useEffect(() => {
		const timer = setTimeout(() => {
			getSoaringCategory();
		}, 100);
		return () => clearTimeout(timer);
	}, [dateLength]);

	const getSoaringCategory = useCallback(async () => {
		setLoading(true);
		const param = {
			offset: 0,
			pageSize: 5,
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			dateType: 0,
			startDate: moment()
				.subtract(dateLength, "days")
				.startOf("days")
				.format("YYYYMMDDHHmm"),
			endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
		};
		const res = await summaryApi.readDashboardCategorySoaring(param);
		if (res.code === 200) {
			setCategoryList(res.result);
		} else {
			setCategoryList([]);
		}
		setLoading(false);
	}, [dateLength]);

	const categoryEventHandle = (category_event) => {
		const brTagReplaceN = category_event.replace(/<br\s*\/?>/g, "\n");
		const htmlTagPattern = /<[^>]*>/g;
		let textWithoutHtmlTags = brTagReplaceN.replace(htmlTagPattern, "");

		// 문자열이 연속된 줄바꿈 문자로 시작할 경우 삭제
		textWithoutHtmlTags = textWithoutHtmlTags.replace(/^(\n)*/, "");
		if (textWithoutHtmlTags.indexOf("\n") === -1) {
			return textWithoutHtmlTags;
		} else {
			return textWithoutHtmlTags.substring(
				0,
				textWithoutHtmlTags.indexOf("\n")
			);
		}
	};

	return (
		<div className={`dashboard-component`} style={{ width: "100%" }}>
			<h3>인기 게시물</h3>

			<div className={`dashboard-popular-category-list`}>
				<div className={`table-list-row`}>
					<p className={`category-font`}>카테고리명</p>
					<p className={`number-font`}>총 조회수</p>
					<p className={`number-font`}>실시간 상승</p>
				</div>
				<Skeleton
					loading={loading}
					active={loading}
					size={"large"}
					block={true}
					style={{
						height: "6em",
						padding: "1em 0",
					}}
					title={null}
					paragraph={{
						rows: 5,
						width: "100%",
					}}
				>
					{categoryList?.map((item, idx) => (
						<div className={`table-list-row`} key={`popular-category-${idx}`}>
							<div
								className={`category-font`}
								style={{
									display: "flex",
									alignItems: "center",
									gap: "0.5em",
								}}
							>
								<p>{idx + 1}</p>
								<p className={`table-category-id`}>
									{convertCategoryType(item)}
								</p>
								<p className={`table-category-name`}>
									{item?.view_num > 300 && (
										<span
											style={{
												backgroundColor: "#fe2b4b",
												marginRight: 3,
												fontWeight: 500,
												fontSize: "0.8em",
												color: "white",
												padding: "2px 4px",
												borderRadius: "6px",
											}}
										>
											HOT
										</span>
									)}
									{item?.category_type === "recommend_nutrients"
										? "문의글"
										: item?.category_type === "event"
										? categoryEventHandle(item.category_name)
										: item.category_name}
								</p>
							</div>
							<p className={`number-font`}>
								{item?.total_count
									? item?.total_count?.toLocaleString()
									: item?.view_num?.toLocaleString()}
							</p>
							<p
								className={`number-font`}
								style={{
									color: "#df1d1d",
								}}
							>
								+ {item?.view_num?.toLocaleString()}
							</p>
						</div>
					))}
				</Skeleton>
			</div>

			{!categoryList?.length && !loading && (
				<Row
					align={"middle"}
					style={{
						width: "100%",
						flexDirection: "column",
						padding: "2em 0",
					}}
				>
					<img
						src={`/assets/images/warning.png`}
						alt={`warning-icon`}
						style={{
							width: "3em",
							height: "auto",
						}}
					/>
					<p
						style={{
							marginTop: "1em",
							color: "#adb5bd",
							fontSize: "1.1em",
							fontWeight: 500,
						}}
					>
						조회된 게시물이 없습니다.
					</p>
				</Row>
			)}
			<p className={`light-gray`} style={{ marginLeft: "auto" }}>
				2일 기준
			</p>
			<div className={`dashboard-component-footer`}>
				<Link
					to={`/reports_analysis/category`}
					className={`dashboard-footer-font`}
				>
					카테고리 분석으로 이동
				</Link>
			</div>
		</div>
	);
};

export default PopularCategory;
